import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import type { Participant } from "../../models/api/participant";
import { FinancialProfileFooter } from "./financial-profile-footer.component";
import { ProfileSection } from "./financial-profile-section.component";
import { useStyles } from "./financial-profile.styles";

interface FinancialProfileProps {
  participantProfile: Participant;
  handleClose: () => void;
}

export const FinancialProfile = (props: FinancialProfileProps) => {
  const { participantProfile, handleClose } = props;
  const classes = useStyles({});

  return (
    <Dialog
      open
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      PaperProps={{ className: classes.dialog }}
      classes={{
        scrollPaper: classes.topScrollPaper,
      }}
    >
      <div id="financialProfileDialog" className={classes.dialogContent}>
        <DialogTitle disableTypography>
          <Typography variant="h6">Your Financial Profile</Typography>
          <IconButton
            data-testid="close-button"
            aria-label="close"
            onClick={handleClose}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <ProfileSection
              participantProfile={participantProfile}
              handleClose={handleClose}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <FinancialProfileFooter handleClose={handleClose} />
        </DialogActions>
      </div>
    </Dialog>
  );
};
